import { create } from 'zustand';

export interface CaseFilterObject {
	caseStatus: string;
}

export type CaseSortValue = 'createddate_desc' | 'createddate_asc' | '';

const initialCaseFilterObject: CaseFilterObject = {
	caseStatus: '',
};

interface CaseFilterStore {
	caseFilterObject: CaseFilterObject;
	search: string;
	sortValue: CaseSortValue;
	updateCaseFilterObject: (filter: CaseFilterObject) => void;
	updateCaseSearch: (search: string) => void;
	updateCaseSortValue: (sortValue: CaseSortValue) => void;
	resetCaseFilterStore: () => void;
}

export const useCaseFilterStore = create<CaseFilterStore>((set) => ({
	caseFilterObject: { ...initialCaseFilterObject },
	search: '',
	sortValue: '',
	updateCaseFilterObject: (caseFilterObject): void => set(() => ({ caseFilterObject: { ...caseFilterObject } })),
	updateCaseSearch: (search): void => set(() => ({ search })),
	updateCaseSortValue: (sortValue): void => set(() => ({ sortValue })),
	resetCaseFilterStore: (): void =>
		set(() => ({
			caseFilterObject: { ...initialCaseFilterObject },
			search: '',
			sortValue: '',
		})),
}));
